import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, FormControl, Typography } from "@mui/material";
import { useLocation } from "react-router";
import useSWRMutation from "swr/mutation";

import {
  getSettingState,
  setCustomModal,
  setSnackbarMode,
  setSnackbarTitle,
} from "../../../redux/features/settingSlice";
import CustomModal from "../CustomModal";
import { fetcherPost } from "../../../services/fetcher";
import CustomInput from "../CustomInput";
import Spam from "../../../media/svg/Report/Spam";
import Violence from "../../../media/svg/Report/Skull";
import Hand from "../../../media/svg/Report/front_hand";
import Illegal from "../../../media/svg/Report/pill";
import Personal from "../../../media/svg/Report/badge";
import Porno from "../../../media/svg/Report/no_adult_content";
import Other from "../../../media/svg/Report/error";
import CustomButton from "./../CustomButton/index";

const ReportModal = () => {
  const { darkMode, commentId, profileId } = useSelector(getSettingState);
  const dispatch = useDispatch();
  const location = useLocation();
  let urlParams = location.pathname.split("/");
  var reportObj = urlParams.slice(-2);
  const [reportType, setReportType] = useState(null);
  const [reportTypeKey, setReportTypeKey] = useState(null);
  const [reportDetail, setReportDetail] = useState("");

  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;
  const typeObject = () => {
    var reportTypeUrl = reportObj[0];
    var reportIdUrl = reportObj[1];
    if (reportTypeUrl === "table") {
      reportTypeUrl = "table";
    }
    if (reportTypeUrl === "opinions") {
      reportTypeUrl = "opinion";
    }

    if (reportTypeUrl === "discussions") {
      reportTypeUrl = "conversation";
    }
    if (reportTypeUrl === "topics") {
      if (urlParams.slice(-4)[0] === "discussions") {
        reportTypeUrl = "converse";
      }
      if (urlParams.slice(-4)[0] === "opinions") {
        reportTypeUrl = "topic";
      }
    }

    if (reportTypeUrl === "profile") {
      reportTypeUrl = "user";
      reportIdUrl = profileId;
    }
    if (reportIdUrl === "comment") {
      reportTypeUrl = "comment";
      reportIdUrl = commentId;
    }
    return { reportTypeUrl, reportIdUrl };
  };

  const { trigger, isMutating } = useSWRMutation(
    [
      `${process.env.REACT_APP_API}/content/report/${
        typeObject().reportTypeUrl
      }/${typeObject().reportIdUrl}/`,
      tokenStorage,
    ],
    fetcherPost,
    {
      onSuccess: () => {
        dispatch(setSnackbarMode(true));
        dispatch(setSnackbarTitle("Your report is submitted!"));
        dispatch(setCustomModal(false));
        setReportType(null);
        setReportDetail("");
      },
      onError: (e) => {
        if (e.request.statusText === "Unauthorized") {
        }
      },
    }
  );

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await trigger({ report_type: reportTypeKey, detail: reportDetail });
    } catch (e) {}
  };

  const handleClearReportData = () => {
    setReportType(null);
    setReportDetail("");
  };

  const handleReportType = (name) => {
    setReportType(name);
    if (name === "Spam") {
      setReportTypeKey("spam");
    }
    if (name === "Violence") {
      setReportTypeKey("violence");
    }
    if (name === "Child Abuse") {
      setReportTypeKey("child_abuse");
    }
    if (name === "Illegal Drugs") {
      setReportTypeKey("illegal_drugs");
    }
    if (name === "Personal Details") {
      setReportTypeKey("personal_details");
    }
    if (name === "Pornography") {
      setReportTypeKey("pornography");
    }
    if (name === "Others") {
      setReportTypeKey("other");
    }
  };

  const ReportList = [
    {
      name: "Spam",
      icon: <Spam color={!darkMode ? "#424242" : "#F5F5F5"} />,
    },
    {
      name: "Violence",
      icon: <Violence color={!darkMode ? "#424242" : "#F5F5F5"} />,
    },
    {
      name: "Child Abuse",
      icon: <Hand color={!darkMode ? "#424242" : "#F5F5F5"} />,
    },
    {
      name: "Illegal Drugs",
      icon: <Illegal color={!darkMode ? "#424242" : "#F5F5F5"} />,
    },
    {
      name: "Personal Details",
      icon: <Personal color={!darkMode ? "#424242" : "#F5F5F5"} />,
    },
    {
      name: "Pornography",
      icon: <Porno color={!darkMode ? "#424242" : "#F5F5F5"} />,
    },
    {
      name: "Others",
      icon: <Other color={!darkMode ? "#424242" : "#F5F5F5"} />,
    },
  ];

  return (
    <Box>
      <CustomModal closeCallback={handleClearReportData} subject={"Report"}>
        {!reportType ? (
          <Box>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "18px",
                lineHeight: "28px",
                mb: "26px",
              }}
            >
              What is the purpose of bringing this content to light?
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", mb: "10px" }}>
              {ReportList.map((row, i) => {
                return (
                  <Box
                    key={i}
                    sx={{ display: "flex", mb: "22px", cursor: "pointer" }}
                    onClick={() => handleReportType(row.name)}
                  >
                    {row.icon}
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 600,
                        ml: "12px",
                        mt: "1px",
                        color: "gray.main",
                      }}
                    >
                      {row.name}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        ) : (
          <Box sx={{ mb: "40px" }}>
            <Box
              sx={{
                fontSize: "18px",
                lineHeight: "28px",
                mb: "16px",
              }}
            >
              <Typography sx={{ fontWeight: 600, display: "inline-flex" }}>
                {reportType}
              </Typography>{" "}
              was chosen as the subject of the report.
            </Box>
            <Typography
              sx={{
                fontSize: "18px",
                lineHeight: "28px",
                mb: "30px",
              }}
            >
              Please enter any additional details relevant to your report.
            </Typography>
            <FormControl
              component={"form"}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={handleSubmit}
              fullWidth
            >
              <Box sx={{ mb: "22px", width: "100%" }}>
                <CustomInput
                  focused
                  value={reportDetail}
                  onChange={(e) => setReportDetail(e.target.value)}
                  label='Additional details'
                />
              </Box>
              <CustomButton
                submit
                disabled={isMutating}
                title='Send report'
                fSize='20px'
                width='100%'
                height='48px'
                bShadow='4px'
                bgColor='primary.main'
              />
            </FormControl>
          </Box>
        )}
      </CustomModal>
    </Box>
  );
};
export default ReportModal;
